import { RouterProvider } from 'react-router';
import { Toaster } from 'sonner';
import { router } from './routes';
import { useAuthInit } from './lib/hooks/use-auth';
import { Environment } from './config/environment';

function EnvironmentMismatchBanner() {
  const host = globalThis.location?.hostname ?? '';
  const isDevHost = host.includes('dev') || host === 'localhost' || host === '127.0.0.1';
  const isProdHost = host.includes('admin-panel') || host.includes('prod');
  const mismatched = (isDevHost && Environment.isProd) || (isProdHost && Environment.isDev);

  if (!mismatched) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-red-600 px-4 py-2 text-center text-sm font-bold text-white">
      ENVIRONMENT MISMATCH: This is a {Environment.label} build deployed to a{' '}
      {isDevHost ? 'DEV' : 'PROD'} host ({host}). Do NOT use this deploy.
    </div>
  );
}

function App() {
  useAuthInit();

  return (
    <>
      <EnvironmentMismatchBanner />
      <RouterProvider router={router} />
      <Toaster position="top-right" richColors />
    </>
  );
}

export default App;
